module.exports = __webpack_public_path__ + "static/media/majed.b576ca3f.jpg";